import { render, staticRenderFns } from "./MtrlAddMain.vue?vue&type=template&id=7495409f&scoped=true&"
import script from "./MtrlAddMain.vue?vue&type=script&lang=js&"
export * from "./MtrlAddMain.vue?vue&type=script&lang=js&"
import style0 from "./MtrlAddMain.vue?vue&type=style&index=0&id=7495409f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7495409f",
  null
  
)

export default component.exports